import Divider from '@cobliteam/ui/components/Divider';
import Skeleton from '@cobliteam/ui/components/Skeleton';
import Typography from '@cobliteam/ui/components/Typography';
import type React from 'react';

interface ChildrenProps {
  children?: React.ReactNode;
}

interface ChildrenWithTitleProps extends ChildrenProps {
  title: string;
}

const TrackingPopUp = ({ children }: ChildrenProps) => {
  return <div className='[&_p]:!m-0 pointer-events-auto relative flex w-[410px] flex-col gap-y-2.5 overflow-hidden rounded-md bg-white shadow-md'>{children}</div>;
};

const TrackingPopUpHeader = ({ children }: ChildrenProps) => {
  return <div className='flex items-center justify-between gap-5 bg-gray-lightest p-5'>{children}</div>;
};

const TrackingPopUpHeaderMain = ({ children }: ChildrenProps) => {
  return <div className='flex items-center gap-2.5'>{children}</div>;
};

const TrackingPopUpTitle = ({ children }: ChildrenProps) => {
  return (
    <Typography variant='heading-2' className='!text-black !font-medium leading'>
      {children}
    </Typography>
  );
};

const TrackingPopUpContent = ({ children }: ChildrenProps) => {
  return <div className='flex flex-col gap-2.5 px-5 py-2.5'>{children}</div>;
};

const TrackingPopUpInfoRowText = ({ title, children }: ChildrenWithTitleProps) => {
  return (
    <Typography variant='caption-default' className='text-gray-11'>
      <b>{title}</b>: {children}
    </Typography>
  );
};

const TrackingPopUpInfoRow = ({ title, children }: ChildrenWithTitleProps) => {
  return (
    <div className='flex items-center gap-1.5'>
      {title && (
        <Typography variant='caption-bold' className='text-gray-11'>
          {title}:
        </Typography>
      )}
      <Typography variant='caption-default' className='text-gray-11'>
        {children}
      </Typography>
    </div>
  );
};

const TrackingPopUpSkeleton = () => {
  return (
    <Skeleton className='w-full bg-gray-7' height={20}>
      <rect x='0' y='0' width='100%' height='100%' />
    </Skeleton>
  );
};

const TrackingPopUpFooter = ({ children }: ChildrenProps) => {
  return (
    <div>
      <Divider />
      <div className='flex justify-center gap-2.5 px-5 py-2.5'>{children}</div>
    </div>
  );
};

const TrackingPopUpIconWrapper = ({ children }: ChildrenProps) => {
  return (
    <div className='flex rounded-full border-2 border-white shadow'>
      <div className='m-auto'>{children}</div>
    </div>
  );
};

export {
  TrackingPopUp,
  TrackingPopUpHeader,
  TrackingPopUpHeaderMain,
  TrackingPopUpTitle,
  TrackingPopUpContent,
  TrackingPopUpInfoRowText,
  TrackingPopUpInfoRow,
  TrackingPopUpSkeleton,
  TrackingPopUpFooter,
  TrackingPopUpIconWrapper,
};
